export default {
  General: {
    Email: "Email",
    Send: "Send",
    Done: "Done",
    Finish: "Finish",
    Try_again: "Try again",
    or: "or"
  },
  SamsungType: {
    bixby: "With Bixby",
    no_bixby: "Without Bixby",
    home_button: "With Home Button"
  },
  sendEmail: {
    repair_tip1: "This model cannot be repaired with the mobile app. We'll send you the desktop solution via email.",
    check_tip1: "The device check cannot be completed using only the mobile app. We'll send you the desktop solution via email.",
    tip1: "This model cannot be unlocked with the mobile app. We’ll send you the desktop solution via email.",
    tip2: "Please connect your phone to your computer with a data cable for a better success rate.",
    enter_address: "Please enter your email address.",
    enter_correct_address: "Please enter the correct email address",
    confidential: "Your email address will be kept strictly confidential.",
    open_link: "Open {0} on any computer browser to download Dr.Fone.",
    has_sent: "Your Email Has Been Sent",
    almost: "Almost There",
    step1: "Step 1",
    open_email: "Open the email on your computer and use the link we sent you to download the desktop version of Dr.Fone.",
    step2: "Step 2",
    repair_launch_tip: "Launch Dr.Fone System Repair and log in to your account to use the Repair feature.",
    check_launch_tip: "Install the Dr.Fone desktop and sign in with the same account. Click My Device, then follow the on-screen instructions to connect your device. Once connected, click Device Detail to view the detailed check results.",
    launch_tip: "Launch Dr.Fone Unlock and log in to your account to use the unlocking feature.",
    contact_us: "Contact us for assistance."
  },
  Unlock: {
    recoveryMode: "Put your device in Recovery Mode",
    wipe_cache: "Wipe the Cache Partition on your device",
    wipe_data: "Follow the instructions to Wipe data on your device",
    completed: "Unlocking completed",
    completed_tip: "Check whether your device has successfully removed the screen lock. If it fails, please try again.",
    contact_us: "Unlock failed? Contact us for more help."
  },
  UnlockStep: {
    sa1: "1. Power off the   phone and keep your phone connected to the computer ",
    sa2: "2. Press and hold the Volume Up + Bixby + Power button at the same time",
    sa3: "3. Release the keys after the Samsung logo appears and wait for a few seconds",
    sa4: "4. Now, your device should boot into Recovery Mode. Choose the 'Reboot to bootloader' to enter the download mode.",
    sb1: "1. Power off the phone and keep your phone connected to the computer",
    sb2: "2. Press and hold the Power and Volume Up buttons at the same time",
    sb3: "3. And continue holding these two buttons even after the device starts to boot back up",
    sb4: "4. Now, your device should boot into Recovery Mode. Choose the 'Reboot to bootloader' to enter the download mode.",
    sc1: "1. Power off the phone and keep your phone connected to the computer",
    sc2: "2. Press and hold the Volume Up+Home +Power button at the same time",
    sc3: "3. Release the keys after the Samsung logo appears and wait for a few seconds",
    sc4: "4. Now, your device should boot into Recovery Mode. Choose the 'Reboot to bootloader' to enter the download mode.",
    s5: "5. Press the Volume button to select 'Wipe data/factory reset' and then press the Power button to confirm",
    s6: "6. Press the Volume button to select 'Yes', and then press the Power button to confirm",
    s7: "7. Press 'Wipe cache partition' and then select 'Yes'",
    s8: "8. Select 'reboot system now' and press the Power button to confirm. It will take some time for the device to reboot.",
    common1: "Power off your phone.",
    common2: "Press the Volume Up and Power key for a few seconds.",
    common3: "Release all keys when Recovery Mode appears on the screen.",
    m4: "Choose 'Wipe Data'by using Volume keys and the Power button to accept.",
    m5: "Choose 'Wipe All Data'.",
    m6: "Now choose 'Confirm' and wait until the process ends.",
    m7: "Go back to the Main Menu with the Power key.",
    m8: "Select 'Reboot'.",
    m9: "Finally, choose 'Reboot to system'.",
    h4: "Choose 'Clear data' by using Volume keys and the Power button to accept.",
    h5: "Select 'Factory reset'.",
    h6: "Type in the word 'yes' and then select 'Factory reset‘.",
    h7: "During this operation, all your files will be removed.",
    h8: "Select 'Back' to back to the Main Menu.",
    h9: "Finally, choose 'Restart'."
  }
};
